<template>
    <button
            type="button"
            id="hamburger"
            class="hamburger"
            :class="showMenu ? 'is-active': ''"
            @click="toggle">
        <span class="hamburger__item"></span>
    </button>

</template>

<script>
    export default {
        props: {
            showMenu: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            toggle() {
                let toggle = !this.showMenu
                this.$emit('toggle', toggle)
            }
        },
    }
</script>

<style lang="sass" scoped>
    .hamburger
        cursor: pointer
        position: relative
        -webkit-user-select: none
        -moz-user-select: none
        -ms-user-select: none
        user-select: none
        background: transparent
        outline: 0
        padding: 20px
        margin: -20px
        &.is-active
            .hamburger__item
                background: transparent
                &:before,
                &:after
                    top: 0
                &:before
                    transform: rotate(-45deg)
                &:after
                    transform: rotate(45deg)
        &__item
            background: $color--white
            display: block
            height: 2px
            position: relative
            transition: background .2s ease-out
            width: 24px
            &:before,
            &:after
                content: ""
                display: block
                height: 100%
                position: absolute
                transition: all .2s ease-out
                width: 100%
                background: $color--white
            &:before
                top: 8px
            &:after
                top: -8px

</style>